/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const patchItemTypeRequestSchema = z.object({
  itemLevelId: z.int(),
});
